import { ChevronRight } from '@mui/icons-material';
import {
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Moment from 'react-moment';
import { RunStatus } from '../../../../../components/RunStatus';
import { DATE_FORMAT } from '../../../../../consts';
import { ChevronDown } from '../../../../../icons/chevron-down';
import STRING_KEYS from '../../../../../language/keys';
import { MatchFlowLogsCollapseItem } from '../MatchFlowLogsCollapseItem';
import { style } from './style';

type MatchFlowLogsItemProps = {
  id: string;
  status: string,
  runId: string,
  createdAt: Date | string,
  executionDuration: null | number,
  inputParameters: InputParameters,
  outputParameters: Record<string, unknown>;
}

export const MatchFlowLogsItem = ({
  id,
  status,
  runId,
  createdAt,
  executionDuration,
  inputParameters,
  outputParameters,
}:MatchFlowLogsItemProps):JSX.Element => {
  const [isOpenRow, setIsOpenRow] = useState(false);

  const handleOpenRow = () => {
    setIsOpenRow(!isOpenRow);
  };

  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  if (executionDuration) {
    let remain = executionDuration;

    hours = Math.floor(remain / 3600);
    remain -= (hours * 3600);
    minutes = Math.floor(remain / 60);
    remain -= (minutes * 60);
    seconds = Math.floor(remain);
  }

  return (
    <>
      <TableRow style={ style.row } onClick={ handleOpenRow }>
        <TableCell
          style={ style.fw }
          width={ style.tableCell.arrowCell.width }
        >
          <IconButton
            aria-label="expand row"
            size="medium"
            sx={ style.IconButton.sx }
            onClick={ handleOpenRow }
          >
            {isOpenRow ? <ChevronDown /> : <ChevronRight />}
          </IconButton>
        </TableCell>
        <TableCell width={ style.tableCell.runDateCell.width } style={ style.fw }>
          <Typography variant="subtitle2" style={ style.fw }>
            <Moment format={ DATE_FORMAT.TABLE_LIST }>
              {createdAt}
            </Moment>
          </Typography>
        </TableCell>
        <TableCell width={ style.tableCell.statusCell.width }>
          <RunStatus
            status={ STRING_KEYS.PROGRESS_STATUSES[status] }
          />
        </TableCell>
        <TableCell width={ style.tableCell.idCell.width }>
          <Typography variant="body2" style={ style.fw }>
            {runId}
          </Typography>
        </TableCell>
        <TableCell width={ style.tableCell.runTimeCell.width }>
          <Typography variant="body2" style={ style.fw }>
            {executionDuration && `${hours}h ${minutes}min ${seconds}sec`}
          </Typography>
        </TableCell>
      </TableRow>
      <MatchFlowLogsCollapseItem
        matchFlowId={ id }
        inputParameters={ inputParameters }
        outputParameters={ outputParameters }
        isOpenRow={ isOpenRow }
      />
    </>
  );
};
